import React from 'react';

import Loading from '../../components/base/Loading';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { ProfileView } from '@relyant/ui';

export const ProfileComponent = ({ profileSections }: { profileSections? }) => {
  return <ProfileView profileSections={profileSections || ['user', 'organization']} />;
};

export default withAuthenticationRequired(ProfileComponent, {
  onRedirecting: () => <Loading />,
});
